<template>
  <div class="my">
    <div class="bg-pic" :style="'background-image:url('+img.member_bg+')'">
      <div class="userinfo" @click="goMember">
       <img class="avatar" :src="user && user.avatar ? user.avatar : img.avatar">
       <img class="approve" :src="img.approve">
       <div class="nickname-box">
        <div class="userinfo-nickname">{{ user ? user.username : '登录/注册' }}</div>
        <div class="userinfo-grade">
         <img class="lv-pic" :src="img.lv">1
       </div>
     </div>
   </div>
 </div>
 <div class="tools-list" hidden="true">
   <div class="tools-items">
     <div class="nav_list">
       <a class="resin" href="redpacket">
         <p class="f-14">我的红包</p>
         <p class="f-num">￥100.00</p>
       </a>
       <a class="resin" href="integral">
         <p class="f-14">我的积分</p>
         <p class="f-num">165</p>
       </a>
     </div>
   </div>
 </div>
 <div class="action-box" hidden="true">
  <div class="f-14 f-w pd-15">我的订单</div>
  <van-grid>
    <van-grid-item :icon="img.orderPay" text="待付款" />
    <van-grid-item :icon="img.orderCar" text="待收货(2)" />
    <van-grid-item :icon="img.getGood" text="已完成" />
    <van-grid-item :icon="img.orderClose" text="已取消" />
  </van-grid>
</div>
<div class="action-box">
  <div class="f-14 f-w pd-15">个人中心</div>
  <van-grid>
    <!-- <van-grid-item :icon="img.collect" text="我的收藏" @click="pageUrl('/my/collect')" /> -->
    <!-- <van-grid-item :icon="img.question" text="我的问答"  @click="pageUrl('/my/ask')" /> -->
    <!-- <van-grid-item :icon="img.post" text="我的帖子"  @click="pageUrl('/my/bbs')" /> -->
    <!-- <van-grid-item :icon="img.motormaster" text="车主认证" :to="{name: 'MyCars'}" /> -->
    <!-- <van-grid-item :icon="img.message" text="消息"  @click="pageUrl('/my/message')" /> -->
    <!-- <van-grid-item :icon="img.memberInfo" text="用户信息"  @click="pageUrl('/my/info')" /> -->
    <van-grid-item :icon="img.post" text="我的帖子" :to="{name: 'MyBbs'}" />
    <van-grid-item :icon="img.message" text="消息" :to="{name: 'MyMessage'}"  />
    <van-grid-item :icon="img.memberInfo" text="用户信息" :to="{name: 'MyMemberInfo'}" />
    <van-grid-item :icon="img.safety" text="账号安全" :to="{name: 'MySafety'}" />
  </van-grid>
</div>
</div>
</template>
<script>
  import list from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { Swipe, SwipeItem, Grid, GridItem } from "vant";
  export default {
    data () {
      return {
        list: [],
        img:{
          member_bg: require('../../../assets/img/member/member_bg.png'),
          lv: require('../../../assets/img/member/LV.png'),
          approve: require('../../../assets/img/member/approve.png'),
          collect:require('../../../assets/img/member/collect.png'),
          question:require('../../../assets/img/member/question.png'),
          post:require('../../../assets/img/member/post.png'),
          motormaster:require('../../../assets/img/member/motormaster.png'),
          message:require('../../../assets/img/member/message.png'),
          memberInfo:require('../../../assets/img/member/memberInfo.png'),
          safety:require('../../../assets/img/member/safety.png'),
          orderPay:require('../../../assets/img/member/orderPay.png'),
          orderCar:require('../../../assets/img/member/orderCar.png'),
          getGood:require('../../../assets/img/member/getGood.png'),
          orderClose:require('../../../assets/img/member/orderClose.png'),
          avatar: require('../../../assets/img/default.jpg')
        }
      }
      
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      if(this.source == 1) {
        this.$store.commit('param/show', true)
        this.$store.commit('param/active', 'My')
      } else {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          }
        })

        this.$store.commit('param/show', false)
        this.$appService.isShowReturn({state: false})
      }
      this.weburl=process.env.VUE_APP_URL
      
    },
    methods: {
      goMember(){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }

        if(this.user) {
          this.$router.push({name: 'MyMemberInfo'})
        }
      },
      pageUrl(url){
        this.$appService.getToken(v => {
            if(v.token) {
              this.$router.push({path: url})
              this.$store.dispatch('param/setToken', v.token)
            } else {
              var params={
                url:this.weburl+url,
                pagetype:2,
                isReturn: true 
              }
              this.$appService.needLogin(params)
            }
          })
      },
    },
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem
    }
  };
</script> 

<style lang="scss">
  .my{
    margin-bottom:60px;
    background-color: #f8f8f8;

    .bg-pic {
     width: 100%;
     height: 220px;
     background-size: 100% 220px;
     background-repeat: no-repeat;
     background-position: center;

     .userinfo {
      position: absolute;
      top: 50px;
      padding: 15px;
      align-items: center;
      display: flex;

      .avatar{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #fff;
      }
      .approve {
        width: 20px;
        height: 20px;
        margin-left: -16px;
        margin-top: 35px;
      }
      .nickname-box{
        margin-left: 15px;

        .userinfo-nickname {
          color: #fff;
          letter-spacing: 3px;
          font-weight:bold;
          font-size:18px;
        }
        .userinfo-grade {
          display: inline-block;
          width: 50px;
          height: 16px;
          border-radius: 50px;
          background-color: rgba(255, 255, 255, 0.5);
          color: #f89200;
          line-height: 1.2;
          text-align: center;
          font-size: 14px;
          vertical-align: middle;
          font-weight: bold;

          .lv-pic {
            width: 10px;
            height: 8px;
          }
        }
      }
    }
  }
  .tools-list {
    margin-top: -34px;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;

    .tools-items {
      background: #fff;
      border-radius: 5px;
      box-shadow: 1px 0 2px 0 #dedad9, 1px 3px 5px 0 #dad4d3;

      .nav_list {
        color: #404040;
        display: flex;
        font-size: 13px;
        justify-content: space-between;

        .resin {
          text-align:center;
          width: 50%;
          color:#000;

          .f-num{
            font-weight:bold;
            font-size:18px;
          }
        }
      }
    }
  }
  .action-box{
    margin-top:20px;
    background:#fff;
  }
  .van-grid-item__content::after{
    border-width: 0;
  }
  .van-hairline--top::after {
    border-top-width: 0;
  }
  .pd-15{
    padding:15px;
  }
  .van-icon__image {
    width: 20px;
    height: 20px;
  }
}
</style>
